import type { UnitInfoFeederScreenInterface } from 'store/units/types';
import { BaseUnitConfig } from 'unitData/BaseUnitConfig';
import type { UnitConfigParams } from 'unitData/BaseUnitConfig';
import type { FeederDeckInterface } from './FeederScreenTypes';
import type { FeederAndScreenStUnitInfoDataMapInterface } from './unitInfoData';

/**
 * /**
 * Returns the default unitinfo object for a FeederScreen
 */
export const getDefaultData = (
  unitInfoData: FeederAndScreenStUnitInfoDataMapInterface,
): UnitInfoFeederScreenInterface => {
  if (!unitInfoData) {
    throw new Error('no unit info data available');
  }
  const defaultFeederDecks: FeederDeckInterface[] = [
    {
      separationSize: Object.values(unitInfoData)[0].defaultSepSizeDeck1,
      display: { separationSize: false },
    },
    {
      separationSize: Object.values(unitInfoData)[0].defaultSepSizeDeck2,
      display: { separationSize: false },
    },
  ];
  return {
    modelName: Object.keys(unitInfoData)[0],
    motorPower: Object.values(unitInfoData)[0].motorPower,
    decks: defaultFeederDecks,
    maxCapa: Object.values(unitInfoData)[0].maxCapacity,
    minCapa: Object.values(unitInfoData)[0].minCapacity,
    maxFeed: Object.values(unitInfoData)[0].maxFeedSize,
    parallelUnits: 1,
    maxGrizzlySep: Object.values(unitInfoData)[0].maxGrizzlySep,
    maxScreenSep: Object.values(unitInfoData)[0].maxScreenSep,
    suitableCrushers: Object.values(unitInfoData)[0].suitableCrushers,
    feederModel: Object.values(unitInfoData)[0].feederModel,
    grizzlyScreenModel: Object.values(unitInfoData)[0].grizzlyScreenModel,
    moisture: 0,
    newMoisture: false,
    display: {
      displayNotes: {
        noteOne: false,
        noteTwo: false,
        noteThree: false,
        noteFour: false,
        noteFive: false,
      },
      displayUnitName: true,
      displayModelName: true,
      displayLoad: true,
      displaySepSizeDeck1: true,
      displaySepSizeDeck2: true,
    },
  };
};

export class FeederScreenConfig extends BaseUnitConfig {
  static getDefaultData(
    params?: UnitConfigParams,
  ): UnitInfoFeederScreenInterface {
    const unitInfoData = params?.data as
      FeederAndScreenStUnitInfoDataMapInterface | undefined;

    if (!unitInfoData) {
      throw new Error('no unit info data available');
    }
    const defaultFeederDecks: FeederDeckInterface[] = [
      {
        separationSize: Object.values(unitInfoData)[0].defaultSepSizeDeck1,
        display: { separationSize: false },
      },
      {
        separationSize: Object.values(unitInfoData)[0].defaultSepSizeDeck2,
        display: { separationSize: false },
      },
    ];
    return {
      modelName: Object.keys(unitInfoData)[0],
      motorPower: Object.values(unitInfoData)[0].motorPower,
      decks: defaultFeederDecks,
      maxCapa: Object.values(unitInfoData)[0].maxCapacity,
      minCapa: Object.values(unitInfoData)[0].minCapacity,
      maxFeed: Object.values(unitInfoData)[0].maxFeedSize,
      ...BaseUnitConfig.getBaseDefaults(),
      maxGrizzlySep: Object.values(unitInfoData)[0].maxGrizzlySep,
      maxScreenSep: Object.values(unitInfoData)[0].maxScreenSep,
      suitableCrushers: Object.values(unitInfoData)[0].suitableCrushers,
      feederModel: Object.values(unitInfoData)[0].feederModel,
      grizzlyScreenModel: Object.values(unitInfoData)[0].grizzlyScreenModel,
      display: {
        ...BaseUnitConfig.getDefaultDisplay(),
        displayLoad: true,
        displaySepSizeDeck1: true,
        displaySepSizeDeck2: true,
      },
    };
  }

  static getNumberOfPorts(): number {
    return 4;
  }
}

export const feederScreenConfig = new FeederScreenConfig();
